import { MapGeometryType } from './IMapWidget.ts';

const multiToBaseType: Record<string, MapGeometryType> = {
  MultiPoint: MapGeometryType.Point,
  MultiLineString: MapGeometryType.LineString,
  MultiPolygon: MapGeometryType.Polygon,
};

/**
 * Normalizza il tipo geometria OL ai tipi base supportati.
 * I tipi Multi* (da upload GeoJSON/shapefile) vengono
 * ricondotti al tipo base corrispondente.
 */
export function normalizeGeometryType(
  rawType: string | undefined,
): MapGeometryType | undefined {
  if (!rawType) return undefined;
  if (rawType in MapGeometryType) return rawType as MapGeometryType;
  return multiToBaseType[rawType];
}

/**
 * Ricava il tipo geometria dal GeoJSON serializzato di una Feature.
 * Alcune geometrie persistite non hanno il campo `geometryType`: in tal
 * caso il tipo va dedotto dalla geometria stessa.
 */
export function getGeometryTypeFromFeatureGeoJson(
  featureGeoJson: string,
): MapGeometryType | undefined {
  try {
    const parsed = JSON.parse(featureGeoJson) as {
      geometry?: { type?: string };
    };
    return normalizeGeometryType(parsed.geometry?.type);
  } catch {
    return undefined;
  }
}
